export default {
  dynamicProducts: [],
  dynamicProductsRaw: null,
  vPage: 0,
  limit: 20,
  vTotalCount: 0,
  vTotalPages: 0,
  softApiCards: [],
}
